import { useState, useEffect } from 'react';

export const useGetGeolocationStatus = () => {
    const [countryCode, setCountryCode] = useState('');
    const [isLoadingCountryCode, setIsLoadingCountryCode] = useState(true);
    const [isErrorCountryCode, setIsErrorCountryCode] = useState(false);

    useEffect(() => {
        const fetchGeolocation = async () => {
            try {
                const response = await fetch('https://ipapi.co/json/');
                const data = await response.json();
                setCountryCode(data.country_code);
            } catch (error) {
                console.error('Error fetching geolocation data:', error);
                setIsErrorCountryCode(true);
            } finally {
                setIsLoadingCountryCode(false);
            }
        };

        fetchGeolocation();
    }, []);

    return { countryCode, isLoadingCountryCode, isErrorCountryCode };
};
